module.exports = __webpack_public_path__ + "img/CTWP__Staff_02.04db6aea.png";